const ClickInfoLearningObject = "Click Info Learning Object";
const ClickInfoLearningObjectAction = "Click_Info_Learning_Object_Action";

export default ClickInfoLearningObject;
export { ClickInfoLearningObject, ClickInfoLearningObjectAction };
